import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {EndpointHomeComponent} from './endpoint-home/endpoint-home.component';

const routes: Routes = [
  {
    path: ':objectId/:userId/:sessionId',
    component: EndpointHomeComponent,
    children: [],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class EndpointRoutingModule {
}
